"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
const stimulus_webpack_helpers_1 = require("@hotwired/stimulus-webpack-helpers");
const stimulus = stimulus_1.Application.start();
const context = require.context("./scripts/stimulus", true, /\.ts$/);
stimulus.load((0, stimulus_webpack_helpers_1.definitionsFromContext)(context));
